import { html } from 'lit-element'
import { ShellElement } from '../../common/shell-element'
import type { I18NEvents } from '../../services/i18n'
import { setDocumentLocale, getCurrentLocale, I18NNamespace } from '../../services/i18n'
import { getEventBus } from '../../services/namespaces/event-bus'

/**
 * Element that allows to interact with the shell instance in a document context
 */

export class GoToShellController extends ShellElement {
  static readonly tagName = 'goto-shell-controller'
  private initialized = false

  /**
   * initialize the controller with shell.  Shell API must be available prior calling this
   */
  public initializeController() {
    this.initialized = true
    if (this.isConnected) {
      this.updateLocale()
      this.subscribeToLocaleChange()
    }
  }

  connectedCallback() {
    super.connectedCallback()
    if (this.initialized) {
      this.updateLocale()
      this.subscribeToLocaleChange()
    }
  }

  render() {
    return html`<slot></slot>`
  }

  private updateLocale = () => {
    setDocumentLocale(getCurrentLocale(), document)
  }

  private subscribeToLocaleChange() {
    const { localeChanged } = getEventBus().subscribeTo<typeof I18NNamespace, typeof I18NEvents>(I18NNamespace)
    localeChanged.on(this.updateLocale)
    this.unsubscribeFunctions.push(() => {
      localeChanged.removeListener(this.updateLocale)
    })
  }
}

declare global {
  interface HTMLElementTagNameMap {
    readonly [GoToShellController.tagName]: GoToShellController
  }
}
